import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"
import UiContentCard from "../../../components/cards/UiContentCard"
import Nike from "../../../../../styles/img/favourites/nike.jpg"
import Loyalty01 from "../../../../../styles/img/loyalty-one.png"
import Loyalty02 from "../../../../../styles/img/loyalty-two.png"
import Loyalty03 from "../../../../../styles/img/loyalty-three.png"
import Loyalty04 from "../../../../../styles/img/loyalty-four.png"
import Loyalty05 from "../../../../../styles/img/loyalty-five.png"

import { UiSlider } from "../../../components/common/UiSlider";
import { UiNextArrow, UiPrevArrow } from "../../../components/common/UiSliderArrows.jsx";


export default function StoresWithCanEarnPoints(props) {
    const learnMore = () => {
    }
    const UiShopSlider = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 5.5,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: false
                }
            },
            {
                breakpoint: 768,
                settings: "unslick"

            }]

    };

    return (
        <>
            <div className='sb-shop-slider'>
                <UiSlider UiSliderSettings={UiShopSlider}>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={Loyalty01}
                                    heading="Netflix"
                                    learnMore={learnMore}
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={Loyalty02}
                                    heading="Gymshark"
                                    learnMore={learnMore}
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={Loyalty03}
                                    heading="Clarks"
                                    learnMore={learnMore}
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={Loyalty04}
                                    heading="Beckham Eyewear"
                                    learnMore={learnMore}
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={Loyalty05}
                                    heading="MVMT Watches"
                                    learnMore={learnMore}
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    <div>
                        <UiRowContainer>
                            <UiCol lg="12">
                                <UiContentCard
                                    cardImg={Loyalty02}
                                    heading="Gymshark"
                                    learnMore={learnMore}
                                    body="From its medieval origins to the digital era, learn from its everything, From its past medieval. From medieval."
                                />
                            </UiCol>
                        </UiRowContainer>
                    </div>
                    
                </UiSlider>
            </div>
        </>
    )
}
